import { Injectable, signal } from '@angular/core';

export interface RequestTrackingContext {
  clientId?: number | string | null;
  assessmentId?: number | string | null;
}

/**
 * Holds the client/assessment identifiers for the assessment currently in progress so `requestTrackingInterceptor` can
 * stamp every outgoing request with `X-Client-Id`/`X-Assessment-Id` headers. Backend logging enrichment reads these
 * headers and, combined with the session-scoped `X-Correlation-ID`, lets a single assessment's activity be traced
 * end-to-end across services.
 */
@Injectable({ providedIn: 'root' })
export class RequestTrackingContextService {
  private readonly clientIdState = signal<number | string | null>(null);
  private readonly assessmentIdState = signal<number | string | null>(null);

  readonly clientId = this.clientIdState.asReadonly();
  readonly assessmentId = this.assessmentIdState.asReadonly();

  setContext(context: RequestTrackingContext): void {
    if (context.clientId !== undefined) {
      this.clientIdState.set(context.clientId ?? null);
    }
    if (context.assessmentId !== undefined) {
      this.assessmentIdState.set(context.assessmentId ?? null);
    }
  }

  clear(): void {
    this.clientIdState.set(null);
    this.assessmentIdState.set(null);
  }
}
